"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
exports.useStyles = styles_1.makeStyles(function (theme) { return ({
    inputBase: {
        borderRadius: 4,
        padding: '2px 8px',
        transition: theme.transitions.create(['box-shadow', 'background-color'], {
            duration: theme.transitions.duration.complex,
        }),
        color: 'hsl(209, 34%, 30%)',
    },
    raised: {
        boxShadow: '0 1px 3px hsla(0, 0%, 0%, .12), 0px 0px 0px white inset, 0 1px 2px hsla(0, 0%, 0%, .24)',
        '&$error': {
            boxShadow: '0 10px 20px hsla(360, 72%, 38%, .15), 0px 0px 0px white inset, 0 3px 6px hsla(360, 72%, 38%, .10)',
            backgroundColor: '#FFEEEE',
        },
        '&:focus-within': {
            backgroundColor: 'hsl(212, 39%, 99%)',
            boxShadow: '0 10px 20px hsla(0, 0%, 0%, .15), 0px 0px 0px white inset, 0 3px 6px hsla(0, 0%, 0%, .10)',
            // '0 2px 0px hsla(0, 0%, 100%, .15), inset 0 2px 2px hsla(0, 0%, 0%, .15), 0px 0px 0px white',
        },
    },
    bordered: {
        border: '2px solid hsl(212, 33%, 89%)',
        '&$large': {
            padding: '4px 16px',
        },
    },
    inset: {
        backgroundColor: 'hsl(210, 36%, 96%)',
        boxShadow: '0 2px 0px hsla(0, 0%, 100%, .15), inset 0 2px 2px hsla(0, 0%, 0%, .15), 0px 0px 0px white',
        '&:focus-within': {
            backgroundColor: '#FFF',
            boxShadow: '0 10px 20px hsla(0, 0%, 0%, .15), 0px 0px 0px white inset, 0 3px 6px hsla(0, 0%, 0%, .10)',
            // '0 1px 3px hsla(0, 0%, 0%, .12), 0px 0px 0px white inset, 0 1px 2px hsla(0, 0%, 0%, .24)',
        },
    },
    flat: {
        backgroundColor: 'hsl(210, 36%, 96%)',
        '&:focus-within': {
            backgroundColor: '#FFF',
            boxShadow: '0 10px 20px hsla(0, 0%, 0%, .15), 0px 0px 0px white inset, 0 3px 6px hsla(0, 0%, 0%, .10)',
            // '0 1px 3px hsla(0, 0%, 0%, .12), 0px 0px 0px white inset, 0 1px 2px hsla(0, 0%, 0%, .24)',
        },
    },
    error: {},
    input: {
        '&::placeholder': {
            transition: theme.transitions.create(['color'], {
                duration: theme.transitions.duration.complex,
            }),
            color: '#455A64',
        },
        '&:focus $label': {
            fontSize: '20px',
        },
    },
    label: {
        color: 'hsl(209, 34%, 30%)',
        '&$focused': {
            color: 'hsl(209, 34%, 30%)',
        },
        transition: theme.transitions.create(['text-shadow'], {
            duration: theme.transitions.duration.complex,
        }),
    },
    labelFocused: {
        color: 'hsl(209, 34%, 30%)',
        textShadow: '0 15px 30px hsla(0, 0%, 0%, .15), 0 6px 12px hsla(273, 80%, 49%, .10)',
    },
    labelText: {
        marginBottom: 8,
    },
    large: {
        padding: '4px 0',
        borderRadius: 6,
        fontSize: '1.5rem',
    },
    medium: {
        padding: '4px 16px',
        borderRadius: 6,
        fontSize: '1rem',
    },
    underlined: {
        padding: '2px 0',
        borderRadius: 0,
        borderBottom: '1px solid black',
        '&:focus-within': {
            borderBottom: "1px solid " + theme.palette.primary.main,
        },
        '&$error': {
            borderBottom: '2px solid #f44336',
        },
    },
    focused: {},
    default: {},
}); });
var TextField = react_1.forwardRef(function TextField(_a, ref) {
    var _b;
    var _c = _a.autoFocus, autoFocus = _c === void 0 ? false : _c, _d = _a.autoComplete, autoComplete = _d === void 0 ? 'off' : _d, _e = _a.fullWidth, fullWidth = _e === void 0 ? false : _e, helperText = _a.helperText, id = _a.id, error = _a.error, _f = _a.InputBaseProps, InputBaseProps = _f === void 0 ? {} : _f, label = _a.label, _g = _a.multiline, multiline = _g === void 0 ? false : _g, name = _a.name, rows = _a.rows, size = _a.size, _h = _a.type, type = _h === void 0 ? 'text' : _h, _j = _a.variant, variant = _j === void 0 ? 'default' : _j, value = _a.value, placeholder = _a.placeholder, _k = _a.InputProps, InputProps = _k === void 0 ? {} : _k, other = __rest(_a, ["autoFocus", "autoComplete", "fullWidth", "helperText", "id", "error", "InputBaseProps", "label", "multiline", "name", "rows", "size", "type", "variant", "value", "placeholder", "InputProps"]);
    var classes = exports.useStyles();
    var inputBaseClassName = InputBaseProps.className, inputBaseOther = __rest(InputBaseProps, ["className"]);
    var input = (react_1.default.createElement(core_1.InputBase, __assign({ autoFocus: autoFocus, autoComplete: autoComplete, classes: { input: classes.input }, className: clsx_1.default(classes.inputBase, classes[variant], (_b = {},
            _b[classes.large] = size === 'large',
            _b[classes.medium] = size === 'medium',
            _b[classes.error] = error,
            _b), inputBaseClassName), fullWidth: fullWidth, id: id, value: value, name: name, type: type, multiline: multiline, rows: rows, placeholder: placeholder, inputRef: ref }, inputBaseOther, InputProps)));
    return (react_1.default.createElement(core_1.FormControl, __assign({ fullWidth: fullWidth, error: error }, other),
        label && (react_1.default.createElement(core_1.FormLabel, { className: classes.label, classes: { focused: classes.labelFocused }, htmlFor: id },
            react_1.default.createElement("div", { className: classes.labelText }, label),
            input)),
        !label && input,
        helperText && react_1.default.createElement(core_1.FormHelperText, null, helperText)));
});
exports.default = TextField;
//# sourceMappingURL=TextField.js.map